import React from 'react';

const Footer = () => {
  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', background: '#1b89ff', color: '#fff' }}>
      <p style={{ textAlign: 'center' }}><b>&copy; 2024 Laboratory of Thermal Sciences (Latermo)</b></p>
    </div>
  );
};

export default Footer;